import * as React from 'react';
import {Route, RouteProps} from 'react-router';
import {Link} from 'react-router-dom';
import AppNotificationsContainer from '../../containers/AppNotificationsContainers';
import UserPanel from '../../containers/UserPanel';
import logo from '../../images/logo-1.svg';
import Flex from '../Flex';
import Icon, {IconName} from '../Icon';
import Menu, {MenuItemProps} from '../Menu';
import Header from './Header';
import Layout from './Layout';
import Main from './Main';
import MainContainer from './MainContainer';
import Sider from './Sider';

interface GlobalLayoutProps extends RouteProps {}

export default class GlobalLayout extends React.Component<
  GlobalLayoutProps,
  {}
> {
  public render() {
    const {children, ...restProps} = this.props;

    return (
      <Route
        render={matchProps => (
          <Layout style={{background: '#F7F7F7'}}>
            <AppNotificationsContainer />
            <Sider>
              <Flex
                center={true}
                style={{
                  background: '#7C4EF6',
                  height: 64,
                  boxSizing: 'border-box'
                }}
              >
                <img src={logo} style={{width: 157}} />
              </Flex>

              <Menu
                renderItem={({label, icon, href}) => (
                  <Link to={href || '/'}>
                    {this._renderMenuIcon(icon as IconName)} {label}
                  </Link>
                )}
                fullWidth={true}
                items={this._menuItems}
              />
            </Sider>

            <MainContainer>
              <Header>
                <UserPanel />
              </Header>
              <Main>
                {React.cloneElement(React.Children.only(children), matchProps)}
              </Main>
            </MainContainer>
          </Layout>
        )}
        {...restProps}
      />
    );
  }

  private get _menuItems(): MenuItemProps[] {
    const {path} = this.props;

    return [
      {
        label: 'Dashboard',
        icon: 'star',
        active: path === '/'
      },
      {
        label: 'Manage Users',
        icon: 'team',
        href: '/users',
        active: Boolean(path && path.startsWith('/users'))
      },
      {
        label: 'Reservations',
        icon: 'book',
        href: '/reservations',
        active: Boolean(path && path.startsWith('/reservations'))
      },
      {
        label: 'Long Term Listings',
        icon: 'appstore',
        href: '/long-term-listings',
        active: Boolean(path && path.startsWith('/long-term-listings'))
      },
      // {
      //   label: 'Listings',
      //   icon: 'appstore',
      //   active: Boolean(path && path.startsWith('/listings'))
      // },
      {
        label: 'Manage Teams',
        icon: 'qrcode',
        href: '/teams',
        active: Boolean(path && path.startsWith('/teams'))
      },
      {
        label: 'Guest Messages',
        icon: 'message',
        href: '/messages',
        active: Boolean(path && path.startsWith('/messages'))
      },
      {
        label: 'Cohost Club Messages',
        icon: 'wechat',
        href: '/cohost-club-messages',
        active: Boolean(path && path.startsWith('/cohost-club-messages'))
      },
      {
        label: 'Ana Messages',
        icon: 'dingding',
        href: '/ana-messages',
        active: Boolean(path && path.startsWith('/ana-messages'))
      },
      {
        label: 'Listing Infos',
        icon: 'dingding',
        href: '/listing-infos',
        active: Boolean(path && path.startsWith('/listing-infos'))
      },
      {
        label: 'Mailing List',
        icon: 'mail',
        href: '/mailing_list',
        active: Boolean(path && path.startsWith('/mailling_list'))
      }
    ];
  }

  private _renderMenuIcon(icon: IconName) {
    if (typeof icon === 'string') {
      return <Icon name={icon as IconName} />;
    }
    return icon;
  }
}



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/GlobalLayout.tsx